/// <reference path="../../types/signalr.d.ts" />

namespace SP {
    export class NumberDoodle {
        input: HTMLInputElement;
        container = document.createElement("div");
        plus = document.createElement("div");
        minus = document.createElement("div");
        onChange: () => void = null;
        constructor(input: HTMLInputElement) {
            this.input = input;
            this.input.type = "number";
            this.value = input.value ? input.value : "0";
            this.container.classList.add("sp_number_doodle", "value");
            this.minus.classList.add("minus");
            this.minus.innerHTML = '<i class="fas fa-minus"></i>';
            this.plus.classList.add("plus");
            this.plus.innerHTML = '<i class="fas fa-plus"></i>';


            this.input.addEventListener("focus", () => { this.input.select(); });

            this.container.appendChild(this.minus);
            this.container.appendChild(this.plus);


            this.input.parentElement.insertBefore(this.container, this.input);
            this.container.prepend(this.input);

            this.plus.addEventListener("pointerdown", () => {
                var newValue = parseFloat(this.value) + 1;
                this.value = newValue.toString();
            });

            this.input.addEventListener("change", () => {
                if (this.onChange != null) this.onChange();
            });

            this.minus.addEventListener("pointerdown", () => {
                var newValue = Math.max(0, parseFloat(this.value) - 1);
                this.value = newValue.toString();
            });
        }


        get value(): string {
            return this.input.value;
        }

        get intValue(): number {
            return parseFloat(this.input.value);
        }

        set value(val: string) {
            if (val != this.input.value) {
                this.input.value = val;
                if (this.onChange != null)  this.onChange();
            }
        }
    }
}